
























import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import { imagePlaceholderProduct } from "~/common";

export default {
  name: "CategoryCard",
  components: { MoominLink },
  props: {
    label: String,
    image: {
      type: Object,
      default: () => ({
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      }),
    },
    link: String,
    backgroundLabel: {
      type: String,
      default: "var(--c-secondary)",
    },
  },
  methods: {
    getImageSource() {
      return this.$device.isDesktop ? this.image.desktop : this.image.mobile;
    },
  },
};
